import { Navigate, Outlet } from 'react-router-dom';
import useAppSelector from "../hooks/useAppSelector";

const AuthLayout = () => {
    const isAuth = useAppSelector(state=>state.user.isAuth)

    if (isAuth) {
        return <Outlet />
    }

    return <Navigate to={"/login"} replace />;
};

export default AuthLayout